import { render, staticRenderFns } from "./TeacherRegister.vue?vue&type=template&id=75806b4e"
import script from "./TeacherRegister.vue?vue&type=script&lang=js"
export * from "./TeacherRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75806b4e')) {
      api.createRecord('75806b4e', component.options)
    } else {
      api.reload('75806b4e', component.options)
    }
    module.hot.accept("./TeacherRegister.vue?vue&type=template&id=75806b4e", function () {
      api.rerender('75806b4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/occurrence/TeacherRegister.vue"
export default component.exports